export default __webpack_public_path__ + "static/media/whatsapp_marketing.646924b1.png";